import { Link } from "react-router-dom";
import { ArrowRight, Mail } from "lucide-react";
import { SplitLines } from "./Motion";
import { Star } from "./brand/Logo";
import { useLang } from "../i18n/LangContext";
import { EMAIL, EMAIL_HREF } from "../i18n/strings";

export const CtaBand = () => {
  const { t, path } = useLang();
  return (
    <section className="relative overflow-hidden border-t border-white/10 py-28 md:py-40" data-testid="cta-band">
      <div className="pointer-events-none absolute -right-40 top-1/2 h-[700px] w-[700px] -translate-y-1/2 bg-[radial-gradient(circle,rgba(183,148,246,0.22),transparent_65%)]" />
      <div className="relative mx-auto max-w-[1440px] px-5 md:px-10">
        <p className="label flex items-center gap-3 text-lav"><Star className="star-spin h-5 w-5 text-lav" />{t.common.tagline}</p>
        <h2 className="mt-10 font-display text-6xl font-extrabold uppercase leading-[0.86] text-ivory accent-safe md:text-8xl lg:text-[120px]">
          <SplitLines lines={t.contact.title} lineClass={(i) => (i === 2 ? "text-stroke-lav" : "")} />
        </h2>
        <div className="mt-14 flex flex-wrap items-center gap-4">
          <Link to={path("contact")} data-testid="cta-start-project-button"
            className="label group flex items-center gap-3 rounded-full bg-lav px-8 py-5 text-ink transition-colors duration-300 hover:bg-ivory">
            {t.common.startProject}<ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
          <a href={EMAIL_HREF} data-testid="cta-email-button"
            className="label flex items-center gap-3 rounded-full border border-ivory/30 px-8 py-5 text-ivory transition-colors duration-300 hover:border-lav">
            <Mail className="h-4 w-4 text-lav" />{EMAIL}
          </a>
        </div>
      </div>
    </section>
  );
};
